const series =
{
    "s1": {
        key:'s1',
        name: "serie1",
        image: "/images/series/serie1.png",
        products: ['p1', 'p2', 'p3']
    },
    "s2": {
        key:'s2',
        name: "serie2",
        image: "/images/series/serie1.png",
        products: ['p1', 'p2', 'p3','p4', 'p5','p6','p7','p8']
    },
    "s3": {
        key:'s3',
        name: "serie3",
        image: "/images/icons/image.png",
        products: ['p1', 'p2', 'p3','p4', 'p5']
    },
    "s4": {
        key:'s4',
        name: "serie4",
        image: "/images/series/serie1.png",
        products: ['p1', 'p2', 'p3']
    },
    "s5": {
        key:'s5',
        name: "serie5",
        image: "/images/series/serie1.png",
        products: ['p1', 'p2', 'p3','p4', 'p5','p6','p7','p8']
    },
    "s6": {
        key:'s6',
        name: "serie6",
        image: "/images/icons/image.png",
        products: ['p1', 'p2', 'p3','p4', 'p5']
    },
};

export default series;